import styled from "@emotion/styled";
import { Button, Spacing } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../shared/components";

export const SpinnerContainer = styled(Flexbox)`
    height: ${(Spacing.MD * 3 + Spacing["2XS"]) * 2 + Spacing["3XL"]}px;
    padding-bottom: ${Spacing.MD}px;
`;

export const EditCategoriesButton = styled(Button)`
    margin-bottom: ${Spacing.MD}px;
`;
